<template>
  <!-- <div
    id="app"
    class="container app-main-container"
    :class="store.darkTheme ? 'dark-theme' : 'light-theme'"
  > -->
  <div
    id="app"
    class="container"
    :class="{
      'dark-theme': store.darkTheme,
      'light-theme': !store.darkTheme,
      'app-main-container': signedIn && !isOnboarding,
    }"
  >
    <!-- <Navbar class="main-nav" v-if="signedIn && !isOnboarding"></Navbar>
    <SidebarNav
      class="sidebar"
      v-if="signedIn && !isOnboarding && $route.name != 'SignIn'"
    ></SidebarNav> -->
    <Navbar
      class="main-nav"
      v-if="signedIn && !isOnboarding && $route.name !== 'SignIn'"
    ></Navbar>
    <SidebarNav
      class="sidebar"
      v-if="signedIn && !isOnboarding && $route.name !== 'SignIn'"
    ></SidebarNav>
    <main class="main" id="main" :class="{ 'signin-container': !signedIn }">
      <PlaidReconnectBanner v-if="signedIn && !isOnboarding" />
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </main>
    <!-- <main class="main" id="main" :class="{'signin-container' : !signedIn}">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </main> -->
    <!-- <main class="main" id="main" :class="{ 'signin-container': !signedIn }">
      <KeepAlive>
        <router-view></router-view>
      </KeepAlive>
    </main> -->
    <ErrorMessage ref="errorToast" :errorMessage="errorMessage" />
    <UpdateBanner />
  </div>
</template>
<script>
import { useMyStore } from './store.js';
import {
  ref,
  watch,
  defineComponent,
  computed,
  onBeforeUnmount,
  onMounted,
} from 'vue';

import Navbar from './components/Main-Navbar.vue';
import SidebarNav from './components/Sidebar-Nav.vue';
import ErrorMessage from './components/ErrorMessage.vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { useRouter, useRoute } from 'vue-router';
import { useInactivityTracker } from '@/utils/inactivityTracker';
import { getTokenWithTimeout } from '@/utils/authHelpers';
import UpdateBanner from '@/components/UpdateBanner.vue';
import { useAppUpdateCheck } from '@/composables/useAppUpdateCheck';
import PlaidReconnectBanner from './components/PlaidReconnectBanner.vue';

export default defineComponent({
  components: {
    Navbar,
    SidebarNav,
    ErrorMessage,
    UpdateBanner,
    PlaidReconnectBanner,
  },
  setup() {
    const store = useMyStore();
    let errorMessage = ref('');
    const errorToast = ref(null);

    const { isAuthenticated, getAccessTokenSilently } = useAuth0();

    const router = useRouter();
    const signedIn = computed(() => store.userLoggedIn);
    const { setupActivityListeners, cleanup } = useInactivityTracker(15);
    let inactivitySetup = false;
    const { checkForUpdate } = useAppUpdateCheck();

    const ONBOARDING_ROUTES = new Set([
      'AccountType',
      'UserData',
      'UserCategoryData',
      'ConnectAccounts',
      'ConnectJuniorAccounts',
      'JuniorCategoryData',
      'JuniorUserData',
      'TypeOfAccountCreation',
    ]);

    const route = useRoute();
    const isOnboarding = computed(() => ONBOARDING_ROUTES.has(route.name));

    const showError = (message) => {
      errorMessage.value = message;
      errorToast.value.valueshow();
    };

    watch(
      () => store.userLoggedIn,
      (isSignedIn, wasSignedIn) => {
        if (isSignedIn && !wasSignedIn) {
          setupActivityListeners();
        }
        if (!isSignedIn && wasSignedIn) {
          cleanup();
        }
      }
    );

    watch(
      () => store.authInitialized,
      async (isReady) => {
        if (!isReady) return;

        const token = localStorage.getItem('authToken');
        if (!token) {
          store.updateUserLoggedIn(false);
          store.setAuthInitialized(false);
          router.replace({ name: 'SignIn' });
          return;
        }

        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const exp = payload.exp * 1000;
          if (Date.now() >= exp - 60000) {
            throw new Error('TOKEN_EXPIRED');
          }
        } catch (e) {
          Object.keys(localStorage)
            .filter(
              (k) => k.startsWith('@@auth0spajs@@') || k.startsWith('auth0.')
            )
            .forEach((k) => localStorage.removeItem(k));

          localStorage.removeItem('authToken');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('userLoggedIn');

          sessionStorage.setItem('force_manual_login', '1');

          store.updateUserLoggedIn(false);
          store.setAuthInitialized(false);
          store.setUserDataLoaded(false);

          router.replace({
            name: 'SignIn',
            query: { reason: 'session_expired' },
          });
          return;
        }

        try {
          store.setAuthToken(token);

          const ok = await getUserAccountDataAndPlaidInfo();
          if (ok === false) return;

          store.updateUserLoggedIn(true);
          store.setUserDataLoaded(true);

          if (
            store.userInfo.isNewUser === true &&
            store.user.newUserLoginFlowComplete == false
          ) {
            router.push({ name: 'AccountType' });
          } else {
            router.push({ name: 'Dashboard' });
          }
        } catch (error) {
          console.error('Auth init failed:', error);

          const status = error?.response?.status;
          const isAuthError = status === 401 || status === 403;

          if (isAuthError) {
            try {
              const freshToken = await getTokenWithTimeout(
                getAccessTokenSilently,
                {
                  authorizationParams: {
                    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
                  },
                  cacheMode: 'off',
                },
                5000
              );

              localStorage.setItem('authToken', freshToken);
              store.setAuthToken(freshToken);

              const retryOk = await getUserAccountDataAndPlaidInfo();
              if (retryOk === false) return;

              store.updateUserLoggedIn(true);
              store.setUserDataLoaded(true);

              if (
                store.userInfo.isNewUser === true &&
                store.user.newUserLoginFlowComplete == false
              ) {
                router.push({ name: 'AccountType' });
              } else {
                router.push({ name: 'Dashboard' });
              }
              return;
            } catch (refreshError) {
              console.error('Silent token refresh failed:', refreshError);
            }
          }

          Object.keys(localStorage)
            .filter(
              (k) => k.startsWith('@@auth0spajs@@') || k.startsWith('auth0.')
            )
            .forEach((k) => localStorage.removeItem(k));

          localStorage.removeItem('authToken');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('userLoggedIn');
          sessionStorage.removeItem('auth0_handling');
          sessionStorage.removeItem('auth0_fresh_login');

          sessionStorage.setItem('force_manual_login', '1');

          store.updateUserLoggedIn(false);
          store.setAuthInitialized(false);
          store.setUserDataLoaded(false);

          router.replace({
            name: 'SignIn',
            query: { reason: isAuthError ? 'session_expired' : 'load_failed' },
          });
        }
      },
      { immediate: true }
    );

    // watch(
    //   () => store.authInitialized,
    //   async (isReady) => {
    //     if (!isReady) return;

    //     const token = localStorage.getItem('authToken');
    //     if (!token) {
    //       console.log('No auth token found, redirecting to login');
    //       store.updateUserLoggedIn(false);
    //       store.setAuthInitialized(false);
    //       router.replace({ name: 'SignIn' });
    //       return;
    //     }

    //     try {
    //       const ok = await getUserAccountDataAndPlaidInfo();
    //       if (ok === false) return;

    //       store.updateUserLoggedIn(true);
    //       store.setUserDataLoaded(true);

    //       if (
    //         store.userInfo.isNewUser === true &&
    //         store.user.newUserLoginFlowComplete == false
    //       ) {
    //         router.push({ name: 'AccountType' });
    //       } else {
    //         router.push({ name: 'Dashboard' });
    //       }
    //     } catch (error) {
    //       console.error('authInitialized watcher failed:', error);

    //       const status = error?.response?.status;
    //       const isAuthError = status === 401 || status === 403;

    //       if (isAuthError) {
    //         try {
    //           const freshToken = await getAccessTokenSilently({
    //             authorizationParams: {
    //               audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    //             },
    //             cacheMode: 'off',
    //           });

    //           localStorage.setItem('authToken', freshToken);
    //           store.setAuthToken(freshToken);

    //           const retryOk = await getUserAccountDataAndPlaidInfo();
    //           if (retryOk === false) return;

    //           store.updateUserLoggedIn(true);
    //           store.setUserDataLoaded(true);

    //           if (
    //             store.userInfo.isNewUser === true &&
    //             store.user.newUserLoginFlowComplete == false
    //           ) {
    //             router.push({ name: 'AccountType' });
    //           } else {
    //             router.push({ name: 'Dashboard' });
    //           }
    //           return; // ✅ Success - exit early

    //         } catch (refreshError) {
    //           console.error('Silent token refresh failed:', refreshError);
    //         }
    //       }

    //       localStorage.removeItem('authToken');
    //       localStorage.removeItem('userInfo');
    //       localStorage.removeItem('userLoggedIn');
    //       sessionStorage.removeItem('auth0_handling');
    //       sessionStorage.removeItem('auth0_fresh_login');

    //       store.updateUserLoggedIn(false);
    //       store.setAuthInitialized(false);
    //       store.setUserDataLoaded(false);

    //       router.replace({
    //         name: 'SignIn',
    //         query: { reason: isAuthError ? 'session_expired' : 'load_failed' },
    //       });
    //     }
    //   },
    //   { immediate: true }
    // );

    const getUserAccountDataAndPlaidInfo = async () => {
      try {
        await store.getUserAccountData();
        await store.getAllCategories();
        await store.getPlaidAccountsList();

        try {
          await store.syncPlaidTransactions();
        } catch (syncErr) {
          console.warn(
            '[App] Plaid sync failed during login (non-blocking):',
            syncErr
          );
        }

        return true;
      } catch (error) {
        // console.error('Error in getUserAccountDataAndPlaidInfo:', error);

        // const code = error?.code || error?.response?.data?.errorCode;
        // const institutionId =
        //   error?.institutionId ?? error?.response?.data?.institutionId;

        // if (code === 'ITEM_LOGIN_REQUIRED' && institutionId) {
        //   await store.startUpdateMode(institutionId);
        //   return false;
        // }
        throw error;
      }
    };

    // const getUserAccountDataAndPlaidInfo = async () => {
    //   try {
    //     await store.getUserAccountData();
    //     await store.getAllCategories();
    //     await store.getPlaidAccountsList();
    //     await store.syncPlaidTransactions();
    //     return true;
    //   } catch (error) {
    //     console.error('Error in getUserAccountDataAndPlaidInfo:', error);

    //     const code = error?.code || error?.response?.data?.errorCode;
    //     const institutionId =
    //       error?.institutionId ?? error?.response?.data?.institutionId;

    //     if (code === 'ITEM_LOGIN_REQUIRED' && institutionId) {
    //       await store.startUpdateMode(institutionId);
    //       return false;
    //     }
    //     throw error;
    //   }
    // };

    const handleLogout = () => {
      console.log('handle log out appvue ');
    };

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref');

      if (ref) {
        console.log('[Referral] Found ref:', ref);
        localStorage.setItem('ref', ref);
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      }

      if (signedIn.value) {
        setupActivityListeners();
      }

      checkForUpdate();
    });

    watch(
      () => signedIn.value,
      (newVal) => {
        if (newVal && !inactivitySetup) {
          setupActivityListeners();
          inactivitySetup = true;
        }
      }
    );

    onBeforeUnmount(() => {
      cleanup();
      handleLogout();
    });

    return {
      store,
      isAuthenticated,
      errorMessage,
      showError,
      errorToast,
      signedIn,
      getUserAccountDataAndPlaidInfo,
      handleLogout,
      isOnboarding,
    };
  },
});
</script>

<style scoped>
.app-main-container {
  display: grid;
  grid-template-rows: 9fr 1fr;
  grid-template-columns: 1fr;
  grid-template-areas:
    'main'
    'nav';
  height: 100dvh;
  width: 100%;
}

.light-theme {
  color: #061423;
}

.light-theme {
  background: #ffffff;
}

.dark-theme {
  background: #171e29;
}

.main-nav {
  grid-area: nav;
  align-self: end;
  height: 100%;
}

.sidebar {
  display: none;
}

.light-theme .main-nav {
  background: #ffffff;
}

.dark-theme .main-nav {
  background: #212e3e;
}

.nav {
  grid-area: nav;
}

.main {
  grid-area: main;
  overflow-y: auto;
}

.signin-container {
  /* height: 85%; */
  height: 100vh;
  overflow: hidden;
}

@media screen and (min-width: 992px) {
  .app-main-container {
    grid-template-columns: 1fr 9fr;
    grid-template-areas:
      'sidebar main'
      'sidebar main';
  }

  .sidebar {
    grid-area: sidebar;
    position: static;
    display: flex;
    padding: 1em;
    min-width: 250px;
  }

  .main-nav {
    display: none;
  }
}
</style>
